module.exports = __webpack_public_path__ + "img/carrot.9d4c0c77.svg";